import StatusMetric from './StatusMetric';

export default StatusMetric;
